var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOverview = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.667,
    d: "M7.5 5.836h3.333M7.5 12.5H10M7.5 9.164h5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.667,
    d: "M15.835 9.167V7.5c0-2.357 0-3.536-.733-4.268-.732-.732-1.91-.732-4.267-.732H9.168c-2.357 0-3.536 0-4.268.732S4.168 5.143 4.168 7.5v5c0 2.357 0 3.535.732 4.268s1.91.732 4.268.732h.833"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.583,
    cy: 14.583,
    r: 2.083,
    stroke: "currentColor",
    strokeWidth: 1.667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.667,
    d: "m17.5 17.5-1.25-1.25"
  })));
};
export default SvgOverview;